import { useQuery } from "@tanstack/react-query";
import { getBackendUrl } from "api/common";
import { axiosClient } from "api/http/config";
import { trainListSchema } from "features/VehicleSidebar/VehicleList/TrainList/types";
import { getDate } from "shared/utils/dateTimeUtils";
import { z } from "zod";

export type TrainListRange = z.infer<typeof trainListSchema>;

export const useTrainListRange = (
  fromDate: Date,
  toDate: Date,
  trainSeries: string[],
) => {
  const trainSeriesQuery = trainSeries
    .map((it) => `trainSeries=${it}`)
    .join("&");
  // We can't control Spor's DateRangePicker, so for this invalid state we just use toDate=fromDate.
  const toDateSafe = toDate >= fromDate ? toDate : fromDate;
  return useQuery({
    queryKey: ["trainList", fromDate, toDate, ...trainSeries],
    refetchInterval: 60000,
    queryFn: async ({ signal }) =>
      axiosClient
        .get<TrainListRange>(
          `${getBackendUrl()}/trainList/range?fromDate=${getDate(fromDate)}&toDate=${getDate(toDateSafe)}&${trainSeriesQuery}`,
          {
            signal,
          },
        )
        .then((res) => trainListSchema.parse(res.data)),
  });
};
